const SET_CURRENT_QUESTION_ID = '[exam][question_data]set.current.question.id';
const SET_QUESTION_ID_FROM_QUESTION = '[exam][question_data]set.question.id.from.question';

export {SET_CURRENT_QUESTION_ID, SET_QUESTION_ID_FROM_QUESTION}